// extracted by mini-css-extract-plugin
export default {"menuButtonLabel":"PqMUdwi_nzObg19tpr8j"};